import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ChevronLeft } from '@elliemae/ds-icons';
import { DSBreadcrumb } from '@elliemae/ds-breadcrumb';
import { DSButtonV3, BUTTON_TYPES } from '@elliemae/ds-button-v2';
import { DSHeader } from '@elliemae/ds-header';
import { DSSeparator } from '@elliemae/ds-separator';
import { useSelector } from 'react-redux';
import Common from '../../../../common/services/Common';
import Session, { APPLICATION_NAME, IS_LO } from '../../../../common/services/Session';
import { HeaderToolbar } from '../../../components/Header/HeaderMenu/HeaderTooltip';
import { useLoanInformationField } from '../../../../data/useSelectors';
import { EnvNotificationHeader } from '../../../components/Header/EnvNotificationHeader';
import {
  ScenarioHeaderContainer,
  TopRow,
  BreadcrumbWrapper,
  HeaderWrapper,
} from './styled';
import { SCENARIO_STEPS, PAGE_TITLE } from './constants';

export const ScenarioHeader: React.FC<{ isSingleChannel?: boolean }> = ({ isSingleChannel = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loanId } = useSelector(({ EPPS }: any) => EPPS?.loanPrograms || {});
  const loanIdLoanData = useLoanInformationField('loanId');
  const displayedLoanId = loanId || loanIdLoanData;
  const applicationName = Session.get(IS_LO)
    ? Session.get(APPLICATION_NAME) || 'ENCW'
    : 'EPPS';
  const isSmartClient = applicationName === 'ENC';

  const currentIndex = SCENARIO_STEPS.findIndex(
    (step) => step.path === location.pathname,
  );

  const handleBackClick = () => {
    if (currentIndex > 0) {
      navigate(SCENARIO_STEPS[currentIndex - 1].path);
    } else {
      Common.closeApplication();
    }
  };

  const handleStepClick = (index: number) => {
    // One-directional navigation: only allow backward navigation via breadcrumb
    // Forward navigation is handled by the Next button in the footer
    if (index < currentIndex) {
      navigate(SCENARIO_STEPS[index].path);
    }
  };

  /* NOTE TO DEVS
    Any changes to the main Header component (apps/partner-ui/app/view/components/Header/index.tsx)
    should also be reflected here to keep the Scenario UI experience consistent with the regular pricing flow.
  */
  return (
    <>
      <EnvNotificationHeader />
      <ScenarioHeaderContainer>
      <TopRow>
        <BreadcrumbWrapper>
          <DSButtonV3 buttonType={BUTTON_TYPES.ICON} onClick={handleBackClick} aria-label="Go back">
            <ChevronLeft size="s" />
          </DSButtonV3>
          <DSBreadcrumb trailingSlash={false}>
            {SCENARIO_STEPS.map((step, index) => {
              const isClickable = index < currentIndex && !(index === 0 && isSingleChannel);
              const isDisabledChannel = index === 0 && isSingleChannel;
              return (
                <DSBreadcrumb.Item
                  key={step.path}
                  label={step.label}
                  active={index === currentIndex}
                  {...(isClickable
                    ? { onClick: () => handleStepClick(index) }
                    : { style: {
                        pointerEvents: 'none' as const,
                        ...(isDisabledChannel && { color: '#999' }),
                      } })}
                />
              );
            })}
          </DSBreadcrumb>
        </BreadcrumbWrapper>
        <HeaderToolbar
          loanId={displayedLoanId}
          isSmartClient={isSmartClient}
          handleOpenModal={Common.closeApplication}
        />
      </TopRow>
      <HeaderWrapper>
        <DSHeader text={PAGE_TITLE} fontSize="24px" />
      </HeaderWrapper>
      <DSSeparator
        margin="s"
        orientation="horizontal"
        position="initial"
        type="non-form"
      />
    </ScenarioHeaderContainer>
    </>
  );
};

export default ScenarioHeader;
